import React, { Fragment } from "react";
import ProductDescriptionTab from "./ProductDescriptionTab";
import ProductImageDescriptionSlider from "./ProductImageDescriptionSlider";
import ProductDecoration from "./ProductDecoration";
import RelatedProductSlider from "./RelatedProductSlider";

const ProductDetail = ({ product, source, decoration }) => {
    // Fold the decoration's additional images into the product's own image gallery (same DAM
    // asset shape) instead of showing them in a separate block further down the page.
    const extraImages = (decoration && (decoration.additionalImagesReference || decoration.additionalImages)) || [];
    const enrichedProduct = extraImages.length
        ? { ...product, image: [...(product.image || []), ...extraImages] }
        : product;

    return (
        <Fragment>
            {/* product description with image (incl. decoration's additional images) */}
            <ProductImageDescriptionSlider product={enrichedProduct} />

            {/* product decoration: 3D/AR model + extra description */}
            {decoration && <ProductDecoration decoration={decoration} />}

            {/* product description tab */}
            {product.fullDescription && <ProductDescriptionTab productFullDesc={product.fullDescription} />}

            {/* related product slider */}
            {product.category && product.category[0] && <RelatedProductSlider categoryId={product.category[0]["@id"]} source={source} />}
        </Fragment>
    );
};

export default ProductDetail;
